import { render, staticRenderFns } from "./CreditCardPurchasesTab.vue?vue&type=template&id=5af8e505&scoped=true"
import script from "./CreditCardPurchasesTab.vue?vue&type=script&lang=js"
export * from "./CreditCardPurchasesTab.vue?vue&type=script&lang=js"
import style0 from "./CreditCardPurchasesTab.vue?vue&type=style&index=0&id=5af8e505&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af8e505",
  null
  
)

export default component.exports